import vtkAbstractWidget from './AbstractWidget';
import vtkDistanceRepresentation from './DistanceRepresentation';
import vtkDistanceWidget from './DistanceWidget';
import vtkHandleRepresentation from './HandleRepresentation';
import vtkHandleWidget from './HandleWidget';
import vtkImageCroppingRegionsRepresentation from './ImageCroppingRegionsRepresentation';
import vtkImageCroppingRegionsWidget from './ImageCroppingRegionsWidget';
import vtkLabelRepresentation from './LabelRepresentation';
import vtkLabelWidget from './LabelWidget';
import vtkLineRepresentation from './LineRepresentation';
import vtkLineWidget from './LineWidget';
import vtkOrientationMarkerWidget from './OrientationMarkerWidget';
import vtkPiecewiseGaussianWidget from './PiecewiseGaussianWidget';
import vtkPointPlacer from './PointPlacer';
import vtkResliceCursor from './ResliceCursor/ResliceCursor';
import vtkResliceCursorLineRepresentation from './ResliceCursor/ResliceCursorLineRepresentation';
import vtkResliceCursorWidget from './ResliceCursor/ResliceCursorWidget';
import vtkSphereHandleRepresentation from './SphereHandleRepresentation';
import vtkWidgetRepresentation from './WidgetRepresentation';

export default {
  vtkAbstractWidget,
  vtkDistanceRepresentation,
  vtkDistanceWidget,
  vtkHandleRepresentation,
  vtkHandleWidget,
  vtkImageCroppingRegionsRepresentation,
  vtkImageCroppingRegionsWidget,
  vtkLabelRepresentation,
  vtkLabelWidget,
  vtkLineRepresentation,
  vtkLineWidget,
  vtkOrientationMarkerWidget,
  vtkPiecewiseGaussianWidget,
  vtkPointPlacer,
  vtkResliceCursor,
  vtkResliceCursorLineRepresentation,
  vtkResliceCursorWidget,
  vtkSphereHandleRepresentation,
  vtkWidgetRepresentation,
};
